<template>
  <v-application-view title="History">
    <v-card outlined>
      <v-toolbar flat>
        <v-toolbar-title class="mr-2">Orders</v-toolbar-title>
        <template v-if="type == 'accepted' && accepted.length > 0">
          <v-btn color="success" text>
            <v-icon>mdi-check-all</v-icon>complete
          </v-btn>
        </template>
        <template v-if="type == 'rejected' && rejected.length > 0">
          <v-btn color="success" text>
            <v-icon>mdi-check-all</v-icon>complete
          </v-btn>
        </template>
        <template v-if="type == 'queued' && queued.length > 0">
          <v-btn color="success" text>
            <v-icon>mdi-check-all</v-icon>complete
          </v-btn>
          <v-btn color="error" text>
            <v-icon>mdi-cancel</v-icon>reject
          </v-btn>
        </template>
        <template v-slot:extension>
          <v-tabs color="success" v-model="type">
            <v-tab href="#accepted">
              <v-badge color="success" v-bind:content="accepted_orders.length" inline>Accepted</v-badge>
            </v-tab>
            <v-tab href="#rejected">
              <template v-if="rejected_orders.length > 0">
                <v-badge color="success" v-bind:content="rejected_orders.length" inline>Rejected</v-badge>
              </template>
              <template v-else>
                Rejected
              </template>
            </v-tab>
            <v-tab href="#queued">
              <v-badge color="success" v-bind:content="queued_orders.length" inline>Queued</v-badge>
            </v-tab>
            <v-tab href="#completed">Completed</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items color="success" v-model="type">
        <v-tab-item value="accepted">
          <v-data-table v-model="accepted" show-select item-key="id"
            v-bind:headers="headers" v-bind:items="accepted_orders">
            <template v-slot:item.comments="{item}">
              {{item.comments.length}}
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item value="rejected">
          <v-data-table v-model="rejected" show-select item-key="id"
            v-bind:headers="headers" v-bind:items="rejected_orders">
            <template v-slot:item.comments="{item}">
              {{item.comments.length}}
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item value="queued">
          <v-data-table v-model="queued" show-select item-key="id"
            v-bind:headers="headers" v-bind:items="queued_orders">
            <template v-slot:item.comments="{item}">
              {{item.comments.length}}
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item value="completed">
          <v-data-table v-bind:headers="headers" v-bind:items="completed_orders">
            <template v-slot:item.comments="{item}">
              {{item.comments.length}}
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-application-view>
</template>

<script>
function filter(orders, target){
  var result = []
  for(const index in orders){
    if(orders[index].status == target){
      result.push(orders[index])
    }
  }
  return result
}

export default {
  name: 'History',
  data: () => ({
    type: 'checked',
    accepted: [],
    rejected: [],
    queued: [],
    headers: [
      {text: 'Receiver',     value: 'receiver',     sortable: false},
      {text: 'Amount',       value: 'amount',       sortable: false},
      {text: 'Type',         value: 'type',         sortable: false},
      {text: 'Description',  value: 'description',  sortable: false},
      {text: 'Payment type', value: 'payment_type', sortable: false, width: 150},
      {text: 'Date',         value: 'date',         sortable: false, width: 120},
      {text: 'Comments',     value: 'comments',     sortable: false, width: 80},
      {text: 'Status',       value: 'status',       sortable: false, width: 80},
    ],
    orders: [
      {id: 1, receiver: 'Firdavs Beknazarov', type: 'salary', description: '---', payment_type: 'cash',
          date: '09-03-2020', status: 'completed', amount: 80000, comments: [
            {sender: 'sender', message: 'Why you paying to Firdavs', time: '09-03-2020 11:12:36'}
          ]},
      {id: 2, receiver: 'Firdavs Beknazarov', type: 'salary', description: '---', payment_type: 'cash',
          date: '09-03-2020', status: 'completed', amount: 80000, comments: [
            {sender: 'sender', message: 'Why you paying to Firdavs', time: '09-03-2020 11:12:36'}
          ]},
      {id: 3, receiver: 'Firdavs Beknazarov', type: 'salary', description: '---', payment_type: 'cash',
          date: '09-03-2020', status: 'completed', amount: 80000, comments: [
            {sender: 'sender', message: 'Why you paying to Firdavs', time: '09-03-2020 11:12:36'}
          ]},
      {id: 4, receiver: 'Firdavs Beknazarov', type: 'salary', description: '---', payment_type: 'cash',
          date: '09-03-2020', status: 'completed', amount: 80000, comments: [
            {sender: 'sender', message: 'Why you paying to Firdavs', time: '09-03-2020 11:12:36'}
          ]},
      {id: 5, receiver: 'Firdavs Beknazarov', type: 'salary', description: '---', payment_type: 'cash',
          date: '09-03-2020', status: 'rejected', amount: 80000, comments: [
            {sender: 'sender', message: 'Why you paying to Firdavs', time: '09-03-2020 11:12:36'}
          ]},
      {id: 6, receiver: 'Firdavs Beknazarov', type: 'salary', description: '---', payment_type: 'cash',
          date: '09-03-2020', status: 'accepted', amount: 80000, comments: [
            {sender: 'sender', message: 'Why you paying to Firdavs', time: '09-03-2020 11:12:36'}
          ]},
      {id: 7, receiver: 'Firdavs Beknazarov', type: 'salary', description: '---', payment_type: 'cash',
          date: '09-03-2020', status: 'accepted', amount: 80000, comments: [
            {sender: 'sender', message: 'Why you paying to Firdavs', time: '09-03-2020 11:12:36'}
          ]},
      {id: 8, receiver: 'Firdavs Beknazarov', type: 'salary', description: '---', payment_type: 'cash',
          date: '09-03-2020', status: 'accepted', amount: 80000, comments: [
            {sender: 'sender', message: 'Why you paying to Firdavs', time: '09-03-2020 11:12:36'}
          ]},
      {id: 9, receiver: 'Firdavs Beknazarov', type: 'salary', description: '---', payment_type: 'cash',
          date: '09-03-2020', status: 'accepted', amount: 80000, comments: [
            {sender: 'sender', message: 'Why you paying to Firdavs', time: '09-03-2020 11:12:36'}
          ]},
      {id: 10, receiver: 'Firdavs Beknazarov', type: 'salary', description: '---', payment_type: 'cash',
          date: '09-03-2020', status: 'queued', amount: 80000, comments: [
            {sender: 'sender', message: 'Why you paying to Firdavs', time: '09-03-2020 11:12:36'}
          ]},
      {id: 11, receiver: 'Firdavs Beknazarov', type: 'salary', description: '---', payment_type: 'cash',
          date: '09-03-2020', status: 'queued', amount: 80000, comments: [
            {sender: 'sender', message: 'Why you paying to Firdavs', time: '09-03-2020 11:12:36'}
          ]},
      {id: 12, receiver: 'Firdavs Beknazarov', type: 'salary', description: '---', payment_type: 'cash',
          date: '09-03-2020', status: 'queued', amount: 80000, comments: [
            {sender: 'sender', message: 'Why you paying to Firdavs', time: '09-03-2020 11:12:36'}
          ]},
    ]
  }),
  computed: {
    accepted_orders(){ return filter(this.orders, 'accepted') },
    rejected_orders(){ return filter(this.orders, 'rejected') },
    queued_orders(){ return filter(this.orders, 'queued') },
    completed_orders(){ return filter(this.orders, 'completed') }
  }
}
</script>
